import { useDataQuery } from "hooks/useData";
import React, { useCallback, useMemo } from "react";

type Variant = {
  attribute: number;
  id: string;
  title: string;
  deprecated?: boolean;
  template?: string | null;
};

type VariantEditProps = {
  value: number | null;
  onChange: (v: number | null, template?: string | null) => void;
  attrId: number | undefined;
};

const VariantEdit: React.FC<VariantEditProps> = ({
  value,
  onChange,
  attrId,
}) => {
  const rawVariants = useDataQuery<Variant[]>(`attribute_variants/`, false, []);

  const variants = useMemo(
    () =>
      rawVariants?.filter(
        (v) => !v.deprecated && v.attribute === (attrId ?? 0),
      ) || [],
    [rawVariants, attrId],
  );

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      const v = event.target.value;

      if (v === "reset") {
        onChange(null, null);

        return;
      }
      const id = Number(v) || null;
      const variant = variants.find((item) => Number(item.id) === id);
      onChange(id, variant?.template ?? null);
    },
    [onChange, variants],
  );

  if (!variants || variants.length === 0) return null;

  return (
    <div style={{ margin: "4px 0 8px" }}>
      <select
        id="variant-select"
        value={value || ""}
        onChange={handleChange}
        style={{ padding: "5px", fontSize: "14px", width: "100%" }}
      >
        <option value="reset">
          {value ? "Сбросить" : "Выбрать вариант атрибута"}
        </option>
        {variants.map((variant) => (
          <option
            key={variant.id}
            value={variant.id}
          >
            {variant.title}
          </option>
        ))}
      </select>
    </div>
  );
};

export default VariantEdit;
